import { createRequest } from '@paysera/http-client-common';
import httpClient from '%app/js/httpClient';
import { router } from '%app/js/common/services/router';

class CheckoutClient {
    completeSeatSelectionStep(orderToken) {
        const request = createRequest(
            'PUT',
            router.generate('paysera_checkout.step.seat_selection.complete', { token: orderToken }),
        );

        return httpClient.performRequest(request);
    }
}

export default new CheckoutClient();
